import userService from "./UserService";
import { uploadFileWithTimestamp } from "./StorageService";

export default {
  userService,
  uploadFileWithTimestamp,
};